
import {Component, Prop, Vue} from "vue-property-decorator";
import CounterpartiesAddForm from "@/form/finance/counterparties/CounterpartiesAddForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup}
})
export default class CounterpartiesAddComponent extends Vue {
  @Prop() readonly form!: CounterpartiesAddForm;
}
